import React from "react";
import { createIcon } from "@chakra-ui/icons";

export default createIcon({
  displayName: "BadgeIcon",
  viewBox: "0 0 24 24",
  path: (
    <g>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M6.742 4.738L8.6 1.5 12 3.025v.004-.004L15.4 1.5l1.858 3.238 3.641.773-.39 3.715L23 12l-2.49 2.774.39 3.715-3.641.773L15.4 22.5 12 20.975v-.004.004L8.6 22.5l-1.858-3.238-3.641-.773.39-3.715L1 12l2.49-2.774L3.1 5.51l3.642-.773z"
        clipRule="evenodd"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M15.649 8.72l.963.863L12 14.767l-.91 1.023-3.837-3.85.913-.916 2.87 2.881.964-1.083v.001L15.65 8.72z"
        clipRule="evenodd"
      />
    </g>
  ),
});
